import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResolutionCenterComponent } from './resolution-center.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgSelectModule } from '@ng-select/ng-select';
import { AttachFilesComponent } from './attach-files/attach-files.component';
import { CoachCenterComponent } from './coach-center/coach-center.component';
import { ModalCenterComponent } from './modal-center/modal-center.component';
import { ClientCenterComponent } from './client-center/client-center.component';
import { ClientCenterMantisComponent } from './client-center/client-center-mantis.component';
import { CancellationCenterComponent } from './cancellation-center/cancellation-center.component';
import { RootCenterComponent } from './root-center/root-center.component';
import { ResolutionCenterRoutingModule } from './resolution-center-routing.module';
import { MessageReactionComponent } from './message-reaction/message-reaction.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { MessagesTabModule } from '@shared/components/messages-tab/messages-tab.module';
import { UserInfoSidebarModule } from '@shared/components/user-info-sidebar/user-info-sidebar.module';
import { ChatRoomDetailsSidebarModule } from '@shared/components/chat-room-details-sidebar/chat-room-details-sidebar.module';
import { ClientCenterChatRoomsComponent } from './client-center/client-center-chat-rooms.component';
import { ChatRoomModalComponent } from './client-center/chat-room-modal/chat-room-modal.component';
import { SystemChatRoomModalComponent } from './client-center/system-chat-room-modal/system-chat-room-modal.component';
import { GalleryModule } from '@app/gallery/gallery.module';
import { BroadcastMessagesComponent } from './broadcast-messages/broadcast-messages.component';
import { ManageBroadcastMembersModalComponent } from './broadcast-messages/manage-broadcast-members-modal/manage-broadcast-members-modal.component';

@NgModule({
    declarations: [
        ResolutionCenterComponent,
        AttachFilesComponent,
        CoachCenterComponent,
        ModalCenterComponent,
        ClientCenterComponent,
        ClientCenterMantisComponent,
        ClientCenterChatRoomsComponent,
        BroadcastMessagesComponent,
        ManageBroadcastMembersModalComponent,
        ChatRoomModalComponent,
        SystemChatRoomModalComponent,
        CancellationCenterComponent,
        RootCenterComponent,
        MessageReactionComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        NgSelectModule,
        PaginationModule.forRoot(),
        PopoverModule.forRoot(),
        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        FormsModule,
        ResolutionCenterRoutingModule,
        MessagesTabModule,
        UserInfoSidebarModule,
        ChatRoomDetailsSidebarModule,
        GalleryModule
    ],
    providers: [],
    exports: [ResolutionCenterComponent, ClientCenterChatRoomsComponent, BroadcastMessagesComponent]
})

export class ResolutionCenterModule { }
